export class Loader {
    static get CLASS_LOADER() { return 'unify-pageloader-backdrop'; }
    static get CLASS_LOADER_OPAQUE() { return 'unify-pageloader-backdrop--opaque'; }
    static get CLASS_SPINNER() { return 'unify-pageloader-spinner'; }
    static get CLASS_SPINNER_MESSAGE() { return 'unify-pageloader-spinner__message'; }
    static get CLASS_SPINNER_ROTATOR() { return 'unify-pageloader-spinner__rotator'; }
    static get CLASS_SPINNER_CIRCLE() { return 'unify-pageloader-spinner__circle'; }
    static get CLASS_SPINNER_CIRCLEINVERSE() { return 'unify-pageloader-spinner__circle--inverse'; }
    static get FADE_IN_DELAY_MS() { return 150; }
    static get FADE_DURATION_MS() { return 150; }

    show(isOpaque, message) {
        var backdropEl = document.querySelector('.' + Loader.CLASS_LOADER),
            spinnerEl = document.querySelector('.' + Loader.CLASS_SPINNER);

        if (backdropEl && spinnerEl) {
            /* The loader is visible */
            if (isOpaque && !backdropEl.classList.contains(Loader.CLASS_LOADER_OPAQUE)) {
                backdropEl.classList.add(Loader.CLASS_LOADER_OPAQUE);
            } else if (!isOpaque && backdropEl.classList.contains(Loader.CLASS_LOADER_OPAQUE)) {
                backdropEl.classList.remove(Loader.CLASS_LOADER_OPAQUE);
            }

            this._appendSpinnerMessage(spinnerEl, message);

            if (this.timeoutLoaderFadeOut) {
                /* The loader is fading out */
                clearInterval(this.timeoutLoaderFadeOut);
                this.timeoutLoaderFadeOut = null;

                backdropEl.classList.add('in');
                spinnerEl.classList.add('in');
            }

        } else {
            /* The loader is not visible */
            backdropEl = this._appendBackdrop(isOpaque);
            spinnerEl = this._appendSpinner(message);

            this.timeoutLoaderFadeIn = setTimeout(function () {
                this.timeoutLoaderFadeIn = null;

                backdropEl.classList.add('in');
                spinnerEl.classList.add('in');
            }.bind(this), Loader.FADE_IN_DELAY_MS);
        }
    }

    hide() {
        var backdropEl = document.querySelector('.' + Loader.CLASS_LOADER);
        var spinnerEl = document.querySelector('.' + Loader.CLASS_SPINNER);

        if (backdropEl && spinnerEl) {

            if (this.timeoutLoaderFadeIn) {
                /* The loader is fading in */
                clearTimeout(this.timeoutLoaderFadeIn);
                this.timeoutLoaderFadeIn = null;
                if (document.body.contains(backdropEl)) {
                    document.body.removeChild(backdropEl);
                }
                if (document.body.contains(spinnerEl)) {
                    document.body.removeChild(spinnerEl);
                }
            } else {
                /* The loader is visible */
                backdropEl.classList.remove('in');
                spinnerEl.classList.remove('in');

                this.timeoutLoaderFadeOut = setTimeout(function () {
                    this.timeoutLoaderFadeOut = null;

                    if (document.body.contains(backdropEl)) {
                        document.body.removeChild(backdropEl);
                    }
                    if (document.body.contains(spinnerEl)) {
                        document.body.removeChild(spinnerEl);
                    }
                }.bind(this), Loader.FADE_DURATION_MS);
            }
        }
    }

    _appendBackdrop(isOpaque) {
        var backdropEl = document.createElement('div');
        backdropEl.classList.add(Loader.CLASS_LOADER);
        backdropEl.classList.add('modal-backdrop');
        backdropEl.classList.add('fade');

        if (isOpaque) {
            backdropEl.classList.add(Loader.CLASS_LOADER_OPAQUE);
        }

        document.body.appendChild(backdropEl);

        return backdropEl;
    }

    _appendSpinner(message) {
        var svgNS = 'http://www.w3.org/2000/svg';

        var containerEl = document.createElement('div');
        var rotatorEl = document.createElementNS(svgNS, 'svg');
        var circleEl = document.createElementNS(svgNS, 'circle');
        var circleInverseEl = document.createElementNS(svgNS, 'circle');

        /* add classes */
        containerEl.classList.add(Loader.CLASS_SPINNER);
        containerEl.classList.add('fade');

        if (rotatorEl.classList) {

            rotatorEl.classList.add(Loader.CLASS_SPINNER_ROTATOR);
            circleEl.classList.add(Loader.CLASS_SPINNER_CIRCLE);
            circleInverseEl.classList.add(Loader.CLASS_SPINNER_CIRCLEINVERSE);
        } else {
            /* Fix IE11 crash caused by SVG elements not having a classList */

            var rotatorElClass = rotatorEl.getAttribute('class');
            rotatorEl.setAttribute('class', (rotatorElClass ? rotatorElClass + ' ' : '') + Loader.CLASS_SPINNER_ROTATOR);

            var circleElClass = circleEl.getAttribute('class');
            circleEl.setAttribute('class', (circleElClass ? circleElClass + ' ' : '') + Loader.CLASS_SPINNER_CIRCLE);

            var circleInverseElClass = circleInverseEl.getAttribute('class');
            circleInverseEl.setAttribute('class', (circleInverseElClass ? circleInverseElClass + ' ' : '') + Loader.CLASS_SPINNER_CIRCLEINVERSE);

        }

        /*add svg attributes*/
        rotatorEl.setAttributeNS(null, 'viewBox', '0 0 64 64');

        circleEl.setAttributeNS(null, 'stroke', '#123456');
        circleEl.setAttributeNS(null, 'cx', '32');
        circleEl.setAttributeNS(null, 'cy', '32');
        circleEl.setAttributeNS(null, 'r', '24');

        circleEl.setAttributeNS(null, 'stroke', '#654321');
        circleInverseEl.setAttributeNS(null, 'cx', '32');
        circleInverseEl.setAttributeNS(null, 'cy', '32');
        circleInverseEl.setAttributeNS(null, 'r', '24');

        /*append elements*/
        this._appendSpinnerMessage(containerEl, message);
        rotatorEl.appendChild(circleInverseEl);
        rotatorEl.appendChild(circleEl);
        containerEl.appendChild(rotatorEl);
        document.body.appendChild(containerEl);

        return containerEl;
    }

    getMessage() {
        var spinnerEl = document.querySelector('.' + Loader.CLASS_SPINNER);
        if (!spinnerEl) {
            return undefined;
        }
        var messageEl = spinnerEl.querySelector('.' + Loader.CLASS_SPINNER_MESSAGE);
        return messageEl.textContent;
    }

    _appendSpinnerMessage(spinnerEl, message) {
        if (!spinnerEl) {
            return;
        }
        var messageEl = spinnerEl.querySelector('.' + Loader.CLASS_SPINNER_MESSAGE);
        if (messageEl) {
            if (messageEl.textContent || message && messageEl.textContent !== message) {
                messageEl.classList.remove('in');

                setTimeout(function () {

                    messageEl.textContent = message ? message : '';
                    messageEl.classList.add('in');

                }.bind(this), Loader.FADE_DURATION_MS);
            }
        } else {
            messageEl = document.createElement('span');
            messageEl.classList.add(Loader.CLASS_SPINNER_MESSAGE);
            messageEl.classList.add('fade');
            messageEl.textContent = message ? message : '';
            messageEl.classList.add('in');
            spinnerEl.appendChild(messageEl);
        }
    }
}
